export default "__VITE_ASSET__DcVcOuGx__"